import React, { type ComponentProps } from 'react';
import { View, StyleSheet } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { LinearGradient } from 'expo-linear-gradient';
import Text from '../common/Text';
import { STATS } from '../../data/landingData';

type Props = {
  isMobile: boolean;
};

const StatsBarSection: React.FC<Props> = ({ isMobile }) => {
  return (
    <LinearGradient
      colors={['#4F3D6F', '#9475e1']}
      start={{ x: 0, y: 0 }}
      end={{ x: 1, y: 0 }}
      style={[styles.bar, isMobile && styles.barMobile]}
    >
      <View style={[styles.items, isMobile && styles.itemsMobile]}>
        {STATS.map((stat, i) => (
          <React.Fragment key={stat.label}>
            <View style={[styles.item, isMobile && styles.itemMobile]}>
              <Ionicons
                name={stat.icon as ComponentProps<typeof Ionicons>['name']}
                size={isMobile ? 20 : 24}
                color="rgba(255,255,255,0.7)"
                style={styles.icon}
              />
              <Text style={[styles.value, isMobile && styles.valueMobile]}>
                {stat.value}
              </Text>
              <Text style={[styles.label, isMobile && styles.labelMobile]}>
                {stat.label}
              </Text>
            </View>
            {i < STATS.length - 1 && !isMobile && (
              <View style={styles.divider} />
            )}
          </React.Fragment>
        ))}
      </View>
    </LinearGradient>
  );
};

const styles = StyleSheet.create({
  bar: {
    paddingVertical: 20,
    paddingHorizontal: 24,
  },
  barMobile: {
    paddingVertical: 18,
    paddingHorizontal: 16,
    minHeight: 0,
    width: '100%',
    alignSelf: 'stretch',
  },
  items: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 0,
  },
  itemsMobile: {
    flexWrap: 'wrap',
    gap: 20,
    justifyContent: 'center',
    width: '100%',
    maxWidth: '100%',
    alignSelf: 'stretch',
    flexGrow: 0,
    minWidth: 0,
  },
  item: {
    alignItems: 'center',
    paddingHorizontal: 32,
  },
  itemMobile: {
    paddingHorizontal: 12,
    flexBasis: '46%',
    flexGrow: 1,
    minWidth: 0,
    maxWidth: '50%',
  },
  icon: {
    marginBottom: 6,
  },
  value: {
    fontSize: 28,
    fontWeight: '900',
    color: '#FFFFFF',
    letterSpacing: -0.5,
    lineHeight: 32,
  },
  valueMobile: {
    fontSize: 22,
    lineHeight: 26,
  },
  label: {
    fontSize: 13,
    color: 'rgba(255,255,255,0.75)',
    textAlign: 'center',
    marginTop: 2,
    fontWeight: '500',
    lineHeight: 18,
  },
  labelMobile: {
    fontSize: 11,
  },
  divider: {
    width: 1,
    height: 48,
    backgroundColor: 'rgba(255,255,255,0.2)',
  },
});

export default StatsBarSection;
